import { render, staticRenderFns } from "./index-empty.vue?vue&type=template&id=7504c5b4&"
import script from "./index-empty.vue?vue&type=script&lang=js&"
export * from "./index-empty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports